import { Category } from 'modules/spravochnik/dt-front-page-generator/src/Entity/Category';
import { Api } from 'modules/spravochnik/dt-front-page-generator/src/Api';
import { Module } from 'vuex';

interface CategoryStateInterface {
    categories: Array<Category>,
    category: Category,
}

const categoryModule: Module<CategoryStateInterface, any> = {
    namespaced: true,
    state: {
        categories: [],
        category: null,
    },
    getters: {
        categories(state: CategoryStateInterface): Array<Category> {
            return state.categories;
        },
        category(state: CategoryStateInterface): Category {
            return state.category;
        },
    },
    actions: {
        async loadCategories({ commit, state }) {
            if (state.categories.length > 0) {
                commit('setCategories', state.categories);
                return Promise.resolve();
            }

            const categories = await Api.fetchCategories();
            commit('setCategories', categories);
        },
        async loadCategory({ commit, state }, categoryUrlName: string) {
            for (const categoryElement of state.categories) {
                if (categoryElement.name.urlName === categoryUrlName) {
                    commit('setCategory', categoryElement);
                    return Promise.resolve();
                }
            }

            const category = await Api.getCategory(categoryUrlName);
            commit('setCategory', category);
        },
    },
    mutations: {
        setCategories(state: CategoryStateInterface, list: Array<Category>) {
            state.categories = list;
        },
        setCategory(state: CategoryStateInterface, category: Category) {
            state.category = category;
        },
    },
};

export { categoryModule, CategoryStateInterface };
